import { useCallback, useEffect, useState } from 'react';
import { moldService, moldOrderService } from '../services/api';
import type { MoldStats, MoldOrderStats } from '../types/statistics';

export const useHomepageStats = (autoFetch: boolean = true) => {
	const [moldStats, setMoldStats] = useState<MoldStats | null>(null);
	const [moldOrderStats, setMoldOrderStats] = useState<MoldOrderStats | null>(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<any>(null);

	const fetchStats = useCallback(async () => {
		setLoading(true);
		setError(null);
		try {
			const [moldResp, orderResp] = await Promise.all([
				moldService.getMoldStats(),
				moldOrderService.getMoldOrderStats(),
			]);

			setMoldStats(moldResp.data ?? null);
			setMoldOrderStats(orderResp.data ?? null);
		} catch (err) {
			setError(err);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		if (autoFetch) fetchStats();
	}, [autoFetch, fetchStats]);

	return {
		moldStats,
		moldOrderStats,
		loading,
		error,
		fetchStats,
	};
};